import React, { useContext, useState, useRef } from 'react'
import { ReactSortable } from 'react-sortablejs';
import { getImages } from '../Common/const';
import { VehicleContext } from '../Context/VehicleContext';

const UploadDocument = ({ vin, images, setImages, primaryImage, setPrimaryImage }) => {

    const {uploadDocument, removeBackground} = useContext(VehicleContext);

    const maxFileSize = 32 * 1024 * 1024; // 32 MB in bytes

    const handleImageChange = (event) => {
        uploadFiles(event.target.files);
    };

    const handleDrop = (event) => {
        event.preventDefault();

        uploadFiles(event.dataTransfer.files);
    };

    const uploadFiles = (files) => {
        Array.from(files).map((v,i) => {
            uploadFile(v);
        });
    }

    const uploadFile = (file) => {
        console.log(file);

        if (file && file.size <= maxFileSize) {

            console.log(file);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', 'inventoryphotos/' + vin + '/');
            formData.append('fileName',file.name);
            //formData.append('base_url',true);

            const upload = uploadDocument(formData);
            upload.then((data) => {
                if (data.url && data.data && data.data.key) {
                    //sendChat("",activeChatUser,data.data.key,data.url);

                    console.log(data);

                    setImages(prev => [...prev, {'url':data.url,'key':data.data.key}]);
                    
                } else if(data.error) alert(data.error);
            });
        } else if(file.size > maxFileSize) alert("Image too large");
            
    }


    const [checked, setChecked] = useState([]);
    const checkPrimary = (e) => {
        var checkeds = [...checked];

        if (checkeds.indexOf(e.target.id) > -1) {
            checkeds = checkeds.filter((item) => item !== e.target.id);
        }
        else {
            checkeds.push((e.target.id))
        }
        setChecked(checkeds);
    };

    const isSortingRef = useRef(false);

    const updateOrder = (updatedList) => {
        console.log(updatedList);
        if (!isSortingRef.current) return;
        isSortingRef.current = false;
        setImages(updatedList);
    };

    const deleteItem = () => {
        const filteredImgsURLs = images.filter((item,index) => !checked.includes(String(index)));
        setImages(filteredImgsURLs)
        setChecked([]);
    };

    const handleRemoveBgChange = (event) => {
        removeBackgrounds(event.target.files);
    };

    const removeBackgrounds = (files) => {
        Array.from(files).map((v,i) => {
            removeImageBackground(v);
        });
    }

    const removeImageBackground = (file) => {
        console.log(file);

        if (file && file.size <= maxFileSize) {

            console.log(file);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('vin',vin);
            //formData.append('base_url',true);

            const upload = removeBackground(formData);
            upload.then((data) => {
                if (data.url && data.data && data.data.key) {
                    //sendChat("",activeChatUser,data.data.key,data.url);

                    console.log(data);

                    setPrimaryImage({'url':data.url,'key':data.data.key});
                    
                } else if(data.error) alert(data.error);
            });
        } else if(file.size > maxFileSize) alert("Image too large");

    }

    return (
        <>
            {!images ?

                <div
                    className="form-box"
                    onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleDrop(e);
                    }}
                >
                    <div className="xs-title text-center">
                        Select up to 20 photos you wish to upload
                    </div>
                    <div className="text-center">
                        <button className="black-btn text-uppercase md-btn upload-photo-btn">
                            <input
                                type="file"
                                onChange={(event) => handleImageChange(event)}
                                name="file"
                                accept="image/*"
                                multiple
                            />
                            <img className='me-3' src={getImages('icon-upload-photo.svg')} />
                            Browse Photos
                        </button>
                    </div>
                    <div className="text-center tip-text">
                        Maximum file size 5mb, file format allowed jpg, png, gif
                    </div>
                </div> :
                <div className='up-img-flex'>
                    <div className="d-flex align-items-center upload-action-block mb-1">
                        <div>
                            <button type='button'
                                className="xs-title font-12 text-start text-uppercase text-decoration-none text-white action-link upload-photo-btn">
                                <input type="file" onChange={handleImageChange} name="file" accept="image/*" multiple />
                                <img src={getImages('icon-photos-small.svg')} />
                                Add More Photos
                            </button>
                        </div>
                        {vin && <div className="ms-5">
                            <label htmlFor="file-upload"
                                className="xs-title font-12 text-start text-uppercase text-decoration-none text-white action-link">
                                <img src={getImages('icon-primary.svg')} />&nbsp;&nbsp;
                                {primaryImage && primaryImage.url ? "Replace" : "Upload"} Primary
                                <input
                                    id="file-upload"
                                    type='file' 
                                    accept="image/*"
                                    onChange={(event) => handleRemoveBgChange(event)}
                                    style={{ display: 'none' }} />
                            </label>
                        </div>}
                        <div className="ms-5">
                            <button type='button'
                                className="xs-title font-12 text-start text-uppercase text-decoration-none text-white action-link" onClick={deleteItem}>
                                <img src={getImages('icon-delete-photo.svg')} />
                                Delete
                            </button>
                        </div>
                    </div>
                    <div className='grid-overflow'
                    onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleDrop(e);
                    }}>
                        <div className=''>
                            {primaryImage && 
                                <div className='col-md-3' >
                                    <div className="pl-box dragHandle mt-3">
                                        <div className="pl-img">
                                            <img src={primaryImage.url} onError={() => {setPrimaryImage(null)}}/>
                                        </div>
                                        <div className="mt-2" style={{ color: '#fff' }}>
                                            Primary
                                        </div>
                                    </div>
                                </div>}
                            <ReactSortable
                                ghostClass="dropArea"
                                handle=".dragHandle"
                                filter=".ignoreDrag"
                                preventOnFilter={true}
                                className="grid-container row"
                                dragoverBubble={false}
                                list={images}
                                onUpdate={() => isSortingRef.current = true}
                                setList={(updatedList) => updateOrder(updatedList)}>

                                {images && 
                                    images.map((item, index) => (
                                        <div className='col-md-3' key={index} data-id={index}>
                                            <div className={(checked.indexOf('primaryCheck' + index) > -1) ? "pl-box checked dragHandle mt-3" : "pl-box dragHandle mt-3"}>
                                                <div className="pl-img">
                                                    <img src={item.url} />
                                                </div>
                                                <div className="custom-checkbox admin-checkbox mt-2">
                                                    <input className="styled-checkbox" id={index} type="checkbox"
                                                        // checked={checked.indexOf(index) > -1}
                                                        value={index} onClick={(e) => checkPrimary(e)} onChange={(e) => console.log(e.target.value)} />
                                                    <label htmlFor={index} className='pt-0'><span>{index === 0 ? 'Primary' : 'Select'}</span></label>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </ReactSortable>
                            <div className="text-start tip-text mt-4">Tip: You can drag and drop to re-order.  Max file size 32 mb.</div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default UploadDocument